import { FormGroup } from '@angular/forms';
import { toNum } from '@shared/helpers/math.helper';
import { getControl } from '@shared/helpers/form.helper';

const calcolaPerditeEsercizio = function (form: FormGroup, anno: 'anno1' | 'anno2'): number {
    const suffix = anno === 'anno1' ? '1' : '2';

    const statoPassivoPath = 'my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo';

    const datiBilancioPath = 'my_SezioneI__Rilevazione.my_DatiBilancio';

    const getStatoPassivoValue = (fieldName: string): number => {
        return toNum(getControl(form, `${statoPassivoPath}.${fieldName}${suffix}`).value);
    };

    const AII = getStatoPassivoValue('my_StPaPsAII');
    const AIII = getStatoPassivoValue('my_StPaPsAIII');
    const AIV = getStatoPassivoValue('my_StPaPsAIV');
    const AV = getStatoPassivoValue('my_StPaPsAV');
    const AVI = getStatoPassivoValue('my_StPaPsAVI');
    const AVIItot = getStatoPassivoValue('my_StPaPsAVIItot');
    const AVIII = getStatoPassivoValue('my_StPaPsAVIII');
    const AVII_new = getStatoPassivoValue('my_StPaPsAVII_new');
    const AX = getStatoPassivoValue('my_StPaPsAX');

    const nodoSchemaBilancio: string = getControl(form, `${datiBilancioPath}.my_TipoSchemaBil${suffix}`).value;

    const perdita = nodoSchemaBilancio === 'V' ? -(AII + AIII + AIV + AV + AVI + AVIItot + AVIII) : -(AII + AIII + AIV + AVI + AVIItot + AVII_new + AVIII + AX);

    return perdita < 0 ? 0 : perdita;
};

export const DatiBilancioBisHelpers = {
    calcolaPerditeEsercizio,
};
